import React, { useState } from 'react';
import S from '../../styled';

const ConnectLinkModal = props => {
  const [username, setUsername] = useState(undefined);
  const [canSubmit, setCanSubmit] = useState(!!props.profile);
  const { t } = props.store;
  const { network } = props;

  const updateUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
    setCanSubmit(username.length);
  }

  const confirm = () => {
    if (typeof props.profile === 'string') {
      props.confirm(username, true, network);
    } else {
      const { username, id } = props.profile;
      props.confirm({ username, id }, false, network);
    }
  }

  return (
    <S.Flex alignCenter textAlign='center' column>
      {props.profile && typeof props.profile !== 'string' ? (
        <S.Flex alignCenter textAlign='center' column>
          <S.Flex>
            {t(`components.${network}.confirmAccount`)}
          </S.Flex>
          <S.Flex column margin={20}>
            <S.Flex>
              {props.profile.name}
            </S.Flex>
            <S.Flex>
              {props.profile.username}
            </S.Flex>
          </S.Flex>
        </S.Flex>
      ) : (
        <S.Flex alignCenter textAlign='center' column>
          <S.Flex>
            {t(`components.${network}.enterUsername`)}
          </S.Flex>
          <S.Flex marginTop={20}>
            <S.Input value={username} onChange={updateUsername} />
          </S.Flex>
        </S.Flex>
      )}
      <S.Flex gap={20} margin={20}>
        <S.Button gap={8} onClick={confirm} disabled={!canSubmit}>
          {t('shared.confirm')}
        </S.Button>
        <S.Button secondary onClick={props.cancel}>
          {t('shared.cancel')}
        </S.Button>
      </S.Flex>
    </S.Flex>
  );
}

export default ConnectLinkModal;
